<template>
  <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-position="labelPosition"
      label-width="100px"
  >
    <el-form-item
        label="机器人名称"
        prop="robitName"
    >
      <el-input
          placeholder="请输入"
          v-model="form.robitName"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="接口地址"
        prop="desc"
    >
      <el-input
          placeholder="请输入"
          v-model="form.apiUrl"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="备注"
        prop="remark"
    >
      <el-input
          type="textarea"
          placeholder="请输入"
          v-model="form.remark"
          :rows="3"
          resize="none"
      ></el-input>
    </el-form-item>

    <el-form-item
      label="状态"
      prop="status"
    >
      <el-radio
        v-model="form.status"
        :label="1"
      >启用</el-radio>
      <el-radio
          v-model="form.status"
          :label="0"
      >禁用</el-radio>
    </el-form-item>
  </el-form>
</template>

<script>
import formLabalPosition from "@/mixins/formLabalPosition";
let originForm = {
  robitName: '',
  apiUrl: '',
  remark: '',
  status: 1,
}
export default {
  name: "dingdingForm",
  components:{
  },
  props: {
    formData:{
      type: Object,
      default(){
        return {
          ...originForm,
        }
      }
    },
  },

  data() {
    return {
      form: {
        ...originForm,
      },
      rules:{
        robitName: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        apiUrl:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        remark:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        status:[
          { required: true, message: '请输入', trigger: 'change' },
        ],
      },
    }
  },
  computed: {

  },
  mixins: [formLabalPosition],
  watch:{
    formData:{
      handler(newVal,oldVal){
        if(newVal){
            this.assign(newVal);
        }
      },
      deep:true,
    },
  },
  created(){
      if(this.formData.id){
          this.assign(this.formData);
      }
  },
  methods:{
      assign(formData){
          this.form.id = formData.id;
          this.form.robitName = formData.name;
          this.form.apiUrl = formData.apiUrl;
          this.form.remark = formData.remark;
          this.form.status = formData.status;
      },
    reset(){
      this.form = {
        ...originForm,
      };
    },
    validate(){
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
